import { SiteDesignations } from './siteDesignations';

const configTheme = process.env.LTN_SITE_DESIGNATION || SiteDesignations.LTN_NA;

const themes = {};

themes[SiteDesignations.LTN_NA] = {
  primary: '#88A2AA',
  secondary: '#D2D2D2',
  accent: '#BF4E30',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  white: '#FFFFFF',
  background: '#ebebeb',
};

themes[SiteDesignations.STOCKLOADS_AUSTRALIA] = {
  primary: '#82393d',
  secondary: '#424242',
  accent: '#587B7F',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FB8C00',
  white: '#fdfdfd',
  background: '#ebebeb',
};

// https://coolors.co/c47753-332115-fbf5f3-587b7f-deefb7
themes[SiteDesignations.CENTRAL_VALLEY] = {
  primary: '#332115',  // Bistre (dark brown)
  secondary: '#DEEFB7',    // Tea Green
  accent: '#587B7F',     // Myrtle Green (teal)
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FB8C00',
  white: '#FBF5F3',      // Snow
  background: '#ebebeb',
};

/*
 {
      primary: #795548,
      secondary: #607d8b,
      accent: #009688,
      error: #f44336,
      warning: #ffc107,
      info: #03a9f4,
      success: #4caf50
      }
*/

// default to LTN NA if the site designation isn't found
const selectedTheme = themes[configTheme] || themes[SiteDesignations.LTN_NA];

export const theme = {
  theme: selectedTheme,
};



// WEBPACK FOOTER //
// ./src/theme.js